import { Component, output } from '@angular/core';
import { IconCheckmark } from '../../icons/i-checkmark';
import { IconCross } from '../../icons/i-cross';

@Component({
  selector: 'rid-assessment-toast',
  imports: [IconCheckmark, IconCross],
  templateUrl: './rid-assessment-toast.html',
  host: {
    class: 'block absolute -right-12',
    'animate.enter': 'anim-slide-from-right',
    'animate.leave': 'anim-slide-to-right',
  },
})
export class RidAssessmentToast {
  assessed = output<'CORRECT' | 'INCORRECT'>();
}
